/* eslint-disable react/no-unknown-property */
import React from 'react'

import fallbackImage from 'images/new-viewer-fallback-image.webp'

export function Fallback() {
  return (
    <div className="fallback">
      <picture>
        <source media="(min-width: 640px)" srcSet={fallbackImage} />
        <img
          alt="Hero img"
          loading="eager"
          fetchpriority="high"
          width={331}
          height={308}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </picture>
    </div>
  )
}
